import { Outlet, useParams } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { CommandPalette } from '../../features/search/CommandPalette';
import { AppShell } from './AppShell';

/**
 * Authenticated shell. Project search is available exactly when a project is
 * open, which the route params tell us without threading props through routes.
 */
export const AppLayout = () => {
  const params = useParams({ strict: false }) as { projectCode?: string };
  const projectCode = params.projectCode;
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    if (!projectCode) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        setSearchOpen(true);
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [projectCode]);

  return (
    <AppShell {...(projectCode ? { onOpenSearch: () => setSearchOpen(true) } : {})}>
      <Outlet />
      {projectCode ? (
        <CommandPalette open={searchOpen} onOpenChange={setSearchOpen} projectCode={projectCode} />
      ) : null}
    </AppShell>
  );
};
